import { useEffect, useRef } from "react";

/**
 * KlaviyoEmbed
 * Renders a Klaviyo embedded form. The Klaviyo script (loaded in index.html)
 * scans for elements matching `.klaviyo-form-<ID>` and injects the form.
 *
 * Multiple instances of the same form ID on a page are supported; we give
 * each container a minimum height so the card doesn't collapse before
 * Klaviyo finishes rendering the form.
 */
export default function KlaviyoEmbed({
  formId = "XTJXnc",
  testId = "klaviyo-form",
  className = "",
}) {
  const ref = useRef(null);

  // Nudge Klaviyo to (re)scan when this component mounts, in case the
  // script loaded before this element existed (SPA navigation / hot reload).
  useEffect(() => {
    const tryInit = () => {
      try {
        if (window._klOnsite) {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(["openForm", formId]);
          // The push above ensures the queue is active; Klaviyo auto-scans
          // and injects forms into matching containers.
        }
      } catch (e) {
        // no-op
      }
    };
    // Try now and shortly after, covering the race with script load.
    tryInit();
    const t = setTimeout(tryInit, 600);
    return () => clearTimeout(t);
  }, [formId]);

  return (
    <div
      ref={ref}
      data-testid={testId}
      className={`klaviyo-form-${formId} min-h-[320px] ${className}`}
    />
  );
}
